var b = Object.defineProperty;
var g = (e, n, t) => n in e ? b(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var c = (e, n, t) => g(e, typeof n != "symbol" ? n + "" : n, t);
class O {
  constructor(n) {
    c(this, "logger", null);
    c(this, "events", /* @__PURE__ */ new Map());
    c(this, "publish", (n, t) => {
      var s;
      const r = this.getEventHandlers(n);
      (s = this.logger) == null || s.call(this, "event: ", "publish", `
eventName: `, n, `
params: `, t, `
handlers: `, r), r.forEach((u) => {
        u(t);
      });
    });
    c(this, "subscribe", (n, t) => {
      var s;
      return this.getEventHandlers(n).add(t), (s = this.logger) == null || s.call(this, "event: ", "subscribe", `
event: `, n, `
handler: `, t), () => {
        this.unsubscribe(n, t);
      };
    });
    c(this, "unsubscribe", (n, t) => {
      var s;
      const r = this.getEventHandlers(n);
      if ((s = this.logger) == null || s.call(this, "event: ", "unsubscribe", `
event: `, n, `
handler: `, t), r.size === 0) {
        r.clear();
        return;
      }
      r.delete(t);
    });
    this.logger = n != null ? n : null;
  }
  getEventHandlers(n) {
    let t = this.events.get(n);
    return t || (t = /* @__PURE__ */ new Set(), this.events.set(n, t)), t;
  }
}
function H(e) {
  return Array.isArray(e) ? e.length !== 0 : e != null && e !== "null";
}
class y extends Error {
}
function h(e, n) {
  if (!e)
    throw new y(n);
}
function E(e, n) {
  if (typeof e != typeof n)
    return !1;
  switch (typeof e) {
    case "boolean":
    case "string":
    case "function":
    case "symbol":
    case "undefined":
      return e === n;
    case "bigint":
    case "number":
      return Object.is(e, n);
    case "object": {
      if (h(typeof n == "object", "Assertation error"), e === null && n === null)
        return !0;
      if (e === null || n === null)
        return !1;
      const t = Array.isArray(e), r = Array.isArray(n);
      return t && r ? m(e, n) : t || r ? !1 : A(e, n);
    }
  }
  h(!1, "Assertation error");
}
function m(e, n) {
  if (e.length !== n.length) return !1;
  for (let t = 0; t < e.length; t++) {
    const r = e[t], s = n[t];
    if (!E(r, s))
      return !1;
  }
  return !0;
}
function A(e, n) {
  const t = Object.keys(e).sort(), r = Object.keys(n).sort();
  if (t.length !== r.length)
    return !1;
  for (let s = 0; s < t.length; s++) {
    const u = t[s], i = r[s];
    if (u !== i)
      return !1;
    const o = e[u], f = n[u];
    if (!E(o, f))
      return !1;
  }
  return !0;
}
async function V(e, n = 300) {
  return new Promise((t, r) => {
    setTimeout(() => {
      t(e());
    }, n);
  });
}
const a = {
  ACTIVE_GREEN: "#219653",
  ACTIVE_YELLOW: "#F2C94C",
  ACTIVE_RED: "#EB5757",
  COMPLETED: "#ffffff80"
}, T = "rgba(64, 81, 134, 1)";
function p(e) {
  return (e == null ? void 0 : e.startsWith("light")) === !0;
}
function N(e, n) {
  return e === "COMPLETED" && p(n == null ? void 0 : n.theme) ? T : e in a ? a[e] : e === "ACTIVE" ? a.ACTIVE_GREEN : e === "BAD" ? a.ACTIVE_RED : a.COMPLETED;
}
const D = "—";
function l(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function C(e) {
  return e === "latitude" ? "N" : "E";
}
function _(e, n) {
  return n === "latitude" ? e < 0 ? "S" : "N" : e < 0 ? "W" : "E";
}
function L(e) {
  const n = Math.round(e * 1e3) / 1e3, t = String(n);
  return t.includes(".") ? t.replace(/\.?0+$/, "") : t;
}
function P(e, n, t, r) {
  const s = l(e), u = l(n), i = l(t);
  if (!s && !u && !i)
    return null;
  const o = s ? e : 0, f = u ? n : 0, d = i ? t : 0;
  return (r === "S" || r === "W" ? -1 : 1) * (o + f / 60 + d / 3600);
}
function M(e, n) {
  if (!l(e))
    return {
      degrees: null,
      minutes: null,
      seconds: null,
      hemisphere: C(n)
    };
  const t = e < 0 ? -1 : 1, r = Math.abs(e);
  let s = Math.floor(r);
  const u = (r - s) * 60;
  let i = Math.floor(u), o = (u - i) * 60;
  return o = Math.round(o * 1e3) / 1e3, o >= 60 && (o = 0, i += 1), i >= 60 && (i = 0, s += 1), {
    degrees: s,
    minutes: i,
    seconds: o,
    hemisphere: _(t, n)
  };
}
function R(e, n) {
  var r;
  if (!l(e))
    return D;
  const t = M(e, n);
  return `${t.degrees}° ${t.minutes}′ ${L((r = t.seconds) != null ? r : 0)}″ ${t.hemisphere}`;
}
function W(e, n) {
  if (!l(e))
    return null;
  const t = Math.abs(e);
  return (n === "S" || n === "W" ? -1 : 1) * t;
}
export {
  y as AssertionError,
  O as EventBus,
  a as WELL_STATUS_COLORS,
  W as applyHemisphereToDecimal,
  h as assert,
  M as decimalToDms,
  P as dmsToDecimal,
  E as equalsDeep,
  R as formatGeographicCoordinate,
  N as getWellStatusColor,
  H as hasValue,
  V as testRequestWithDelay
};
//# sourceMappingURL=utils.es.js.map
